import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

import { ScheduleRecordValuesType } from './types'

export const getBackgroundColor = (index: number, days: moment.Moment[]) => {
  return days[index]?.weekday() === 5 || days[index]?.weekday() === 6 ? 'grey100' : 'white'
}

export const gridColumnSpan = (span: number) => {
  return {
    gridColumn: `span ${span}`,
  }
}

export const sumMinutesForDate = (
  date: moment.Moment,
  records: ScheduleRecordValuesType[]
): number => {
  return records.reduce((total, record) => {
    const start = moment(record.startDate)
    const end = moment(record.endDate)

    if (date.isBetween(start, end, 'day', '[]')) {
      return total + record.dailyMinutes
    }

    return total
  }, 0)
}

const formatSecondsToHM = (seconds: number): string => {
  const hours = Math.floor(+seconds / 3600)
  const minutes = Math.ceil(Math.floor(+seconds - hours * 3600) / 60)

  return minutes == 0 ? `${Number(hours)}h` : `${Number(hours)}h ${Number(minutes)}m`
}

export const cellText = (
  minutes: number,
  title?: string | null,
  units?: 'total' | 'daily'
): string => {
  const text = [
    formatSecondsToHM(minutes * 60),
    units === 'total'
      ? i18n.t('project_management.schedule.units.total')
      : i18n.t('project_management.schedule.units.by_day'),
    title ? ` - ${title}` : '',
  ].join('')
  return text
}
